import React from "react";
import { useCookies } from "react-cookie";
import "./CookieConsent.scss";

const CookieConsent: React.FC = () => {
    const [cookies, setCookie] = useCookies(["cookieConsentStatus"]);

    const handleAcceptAll = () => {
        setCookie("cookieConsentStatus", "accepted", { path: "/", maxAge: 31536000 }); // 1 year
    };

    const handleRejectNonEssential = () => {
        setCookie("cookieConsentStatus", "rejected", { path: "/", maxAge: 31536000 }); // 1 year
    };

    if (cookies.cookieConsentStatus) {
        return null; // Don't show if consent is already set
    }

    return (
        <div className="cookie-consent-container">
            <div className="cookie-consent-content">
                <p>
                    We use cookies to enhance your experience, maintain your session, and analyze platform usage. 
                    <strong> Essential cookies</strong> are technically necessary for the platform to function and cannot be disabled. 
                    You can choose to accept or reject <strong>non-essential cookies</strong> (used for analytics and marketing).
                </p>
                <div className="cookie-consent-actions">
                    <button className="reject-btn" onClick={handleRejectNonEssential}>
                        Reject Non-Essential
                    </button>
                    <button className="accept-btn" onClick={handleAcceptAll}>
                        Accept All
                    </button>
                </div>
            </div>
        </div>
    );
};

export default CookieConsent;
